import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [{
  src: 'https://cdn.magicpatterns.com/uploads/tnzNmGPPUMbiiQqagB5Lk4/modulo_1_(1).png',
  label: 'Módulo 1 · Identidad profesional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6BVDBSKJU21iRWDZJK4SdG/modulo_1_(4).png',
  label: 'Módulo 1 · Facultad vs clínica real'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/dVgQjWAku1BNRubsznbtMZ/modulo_1_(15).png',
  label: 'Módulo 1 · Ejercicio práctico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/8fvLFdDXhL4iLjAamAr1hK/modulo_2_(2).png',
  label: 'Módulo 2 · Dispositivo clínico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/p4CtfEExRy8wFWpNMynuKP/modulo_2_(4).png',
  label: 'Módulo 2 · Monotributo y administración'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/tQX7VPNoqNCJ1WwZgT1vqy/modulo_3_(2).png',
  label: 'Módulo 3 · El primer contacto'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eUkmu2yHJ2vLqygSKd2HK3/modulo_3_(3).png',
  label: 'Módulo 3 · Cómo llegan los pacientes'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c1HZqPAUw32RpL9fsQow4m/modulo_0.png',
  label: 'Kit de PPI · Para psicopedagogas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1Zft7fZzjkPNzpmaNrA2JV/modulo_1_(2).png',
  label: 'Kit PPI · ¿Por qué genera inseguridad?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ecH3Xuvf12kUEKGTsuZRJt/modulo_1_(3).png',
  label: 'Kit PPI · ¿Qué es realmente un PPI?'
}];
export function InsideLookCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const goTo = (newIndex: number) => {
    setDirection(newIndex > index ? 1 : -1);
    setIndex((newIndex + slides.length) % slides.length);
  };
  const next = () => goTo(index + 1);
  const prev = () => goTo(index - 1);
  // autoplay
  useEffect(() => {
    const t = setInterval(() => {
      setDirection(1);
      setIndex(i => (i + 1) % slides.length);
    }, 5000);
    return () => clearInterval(t);
  }, []);
  return <section className="container mx-auto px-4 max-w-6xl mb-20" data-id="element-86">
      <div className="text-center mb-8" data-id="element-87">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight mb-2" data-id="element-88">
          👀 Mirá por dentro
        </h2>
        <p className="text-slate-600 text-lg" data-id="element-89">
          Páginas reales del material que vas a recibir
        </p>
      </div>

      <div className="relative" data-id="element-90">
        {/* Main image area */}
        <div className="relative bg-gradient-to-br from-violet-50 via-white to-teal-50/40 rounded-3xl border border-slate-100 shadow-sm p-4 sm:p-8 md:p-10" data-id="element-91">
          <div className="relative w-full max-w-md mx-auto aspect-[3/4] rounded-2xl overflow-hidden bg-white shadow-xl" data-id="element-92">
            <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-93">
              <motion.img key={index} src={slides[index].src} alt={slides[index].label} custom={direction} initial={{
              opacity: 0,
              x: direction > 0 ? 40 : -40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: direction > 0 ? -40 : 40
            }} transition={{
              duration: 0.4,
              ease: 'easeOut'
            }} className="absolute inset-0 w-full h-full object-cover" data-id="element-94" />
            </AnimatePresence>
          </div>

          {/* Caption */}
          <div className="text-center mt-6" data-id="element-95">
            <span className="inline-block bg-white border border-slate-200 text-navy-900 text-sm font-semibold px-4 py-2 rounded-full shadow-sm" data-id="element-96">
              {slides[index].label}
            </span>
          </div>

          {/* Arrows */}
          <button onClick={prev} aria-label="Anterior" className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white shadow-lg border border-slate-100 flex items-center justify-center text-navy-900 hover:bg-violet-50 hover:text-violet-700 transition-colors" data-id="element-97">
            <ChevronLeft className="w-5 h-5" data-id="element-98" />
          </button>
          <button onClick={next} aria-label="Siguiente" className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white shadow-lg border border-slate-100 flex items-center justify-center text-navy-900 hover:bg-violet-50 hover:text-violet-700 transition-colors" data-id="element-99">
            <ChevronRight className="w-5 h-5" data-id="element-100" />
          </button>
        </div>

        {/* Dots */}
        <div className="mt-6 flex justify-center gap-2 flex-wrap" data-id="element-101">
          {slides.map((_, i) => <button key={i} onClick={() => goTo(i)} aria-label={`Ir a slide ${i + 1}`} className={`block h-2 rounded-full transition-all ${i === index ? 'w-8 bg-violet-600' : 'w-2 bg-slate-300 hover:bg-slate-400'}`} data-id="element-102" />)}
        </div>
      </div>
    </section>;
}